module.exports = __webpack_public_path__ + "img/Color 900.d70582c1.jpg";